/* Minomake product page: set picker, gift box, gallery, reviews pager, sticky bar, cart. */
(function(){
  var $ = function(s){ return document.querySelector(s); };
  var $$ = function(s){ return Array.prototype.slice.call(document.querySelectorAll(s)); };
  var D = null;
  var state = {set:'k1', qty:1, gift:false, giftWanted:null};
  var gi = 0, revPage = 0, revOpen = false, io = null, toastTimer, busy = false;

  function money(cents){
    var f = D.money;
    var parts = (cents / 100).toFixed(f.d ? 2 : 0).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.t);
    return f.tpl.replace('[amt]', whole + (f.d ? f.d + parts[1] : ''));
  }

  function render(){
    if (!D || !D.sets[state.set]) return;
    var s = D.sets[state.set];
    // Gift box: free with some sets (ticked unless the parent unticked it), paid otherwise (only if ticked)
    var free = !!s.giftFree;
    state.gift = !!D.gift && (free ? state.giftWanted !== false : state.giftWanted === true);
    var g = $('#gift-wrap'); if (g) g.checked = state.gift;
    var go = $('.gift-opt'); if (go) go.classList.toggle('is-free', free);
    var note = $('#gift-note'); if (note) note.textContent = state.gift ? (free ? D.giftOnFree : D.giftOn) : D.giftOff;
    var total = s.price * state.qty + (state.gift && !free ? D.gift.price : 0);
    $$('.js-total').forEach(function(el){ el.textContent = money(total); });
    var q = $('#qty'); if (q) q.textContent = state.qty;
    var sel = $('#st-select'); if (sel) sel.value = state.set;
    var img = $('#st-img'); if (img && s.img) img.src = s.img;
    $$('.set').forEach(function(l){ var i = l.querySelector('input'); l.classList.toggle('is-on', !!(i && i.checked)); });
    var up = $('#set-up'); if (up) up.hidden = state.set !== 'k1';
  }

  function toast(msg){
    var el = $('#toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ el.hidden = true; }, 2600);
  }

  function addToCart(){
    if (!D || busy) return;
    var s = D.sets[state.set];
    if (!s) return;
    var items = [{id: s.id, quantity: state.qty}];
    var msgOn = $('#msg-on'), msg = $('#gift-msg');
    if (msgOn && msgOn.checked && msg && msg.value.trim()) {
      items[0].properties = {};
      items[0].properties[D.msgProp] = msg.value.trim();
    }
    if (state.gift && D.gift) items.push({id: D.gift.id, quantity: 1});
    busy = true;
    fetch(D.routes.add, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({items: items})
    })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) { var er = new Error(j.description || j.message || D.error); er.isShopify = true; throw er; } return j; }); })
      .then(function(){ return fetch(D.routes.cart, {headers: {'Accept': 'application/json'}}).then(function(r){ return r.json(); }); })
      .then(function(cart){
        busy = false;
        var c = $('#cart-count'); if (c) c.textContent = cart.item_count;
        if (D.after === 'cart') { window.location.href = D.routes.cartUrl; return; }
        if (D.after === 'checkout') { window.location.href = D.routes.checkout; return; }
        toast(D.toast.replace('[set]', s.name).replace('[qty]', state.qty));
      })
      .catch(function(err){ busy = false; toast((err && err.message && err.isShopify) ? err.message : D.error); });
  }

  // "2nd kit" box: moves to the 2-kit set, with its free gift box ticked
  function setUp(v){
    var input = document.getElementById('set-' + v);
    if (!input) return;
    input.checked = true;
    state.set = v;
    state.giftWanted = null;
    render();
    input.focus({preventScroll:true});
  }

  function pick(v){
    var input = document.getElementById('set-' + v);
    if (!input) return;
    input.checked = true;
    state.set = v;
    render();
    var buy = document.getElementById('buy');
    if (buy) buy.scrollIntoView({behavior:'smooth', block:'start'});
    setTimeout(function(){ input.focus({preventScroll:true}); }, 400);
  }

  // Product carousel: a scroll-snap track (swipe on phones, arrows and thumbnails on desktop)
  function track(){ return document.getElementById('stage-track'); }
  function slideCount(){ var t = track(); return t ? t.children.length : 0; }
  function setActive(i){
    var n = slideCount(); if (!n) return;
    gi = Math.max(0, Math.min(n - 1, i));
    var count = $('#g-count'); if (count) count.textContent = (gi + 1) + ' / ' + n;
    $$('.dashes .dash').forEach(function(d, k){ d.classList.toggle('is-on', k === gi); });
    var thumbs = $$('.thumb'), thumbBox = $('.thumbs');
    thumbs.forEach(function(t, k){ t.setAttribute('aria-pressed', k === gi ? 'true' : 'false'); });
    var t = thumbs[gi];
    if (t && thumbBox && thumbBox.offsetParent) {
      if (thumbBox.scrollWidth > thumbBox.clientWidth + 2) {
        thumbBox.scrollLeft = t.offsetLeft - (thumbBox.clientWidth - t.offsetWidth) / 2;
      } else {
        thumbBox.scrollTop = t.offsetTop - (thumbBox.clientHeight - t.offsetHeight) / 2;
      }
    }
  }
  function showImg(i){
    var t = track(), n = slideCount(); if (!t || !n) return;
    i = (i + n) % n;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    t.scrollTo({left: i * t.clientWidth, behavior: reduce ? 'auto' : 'smooth'});
    setActive(i);
  }
  // Scroll events don't bubble, so listen in the capture phase (also works after theme-editor reloads)
  document.addEventListener('scroll', function(e){
    var t = e.target;
    if (!t || !t.clientWidth) return;
    var i = Math.round(t.scrollLeft / t.clientWidth);
    if (t.id === 'stage-track' && i !== gi) setActive(i);
    if (t.id === 'lb-track' && i !== lbI) lbSet(i);
  }, true);

  // Photo popup: opens on the tapped photo; swipe, arrows or arrow keys to browse; × or a tap outside the photo closes
  var lbI = 0;
  function lbBox(){ return document.getElementById('lightbox'); }
  function lbSet(i){
    lbI = i;
    $$('#lightbox .dash').forEach(function(d, k){ d.classList.toggle('is-on', k === i); });
  }
  function lbGo(i, instant){
    var t = document.getElementById('lb-track'), n = t ? t.children.length : 0; if (!n) return;
    zoomOut();
    i = (i + n) % n;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    t.scrollTo({left: i * t.clientWidth, behavior: instant || reduce ? 'auto' : 'smooth'});
    lbSet(i);
  }
  function lbWarm(){ $$('#lb-track img[loading="lazy"]').forEach(function(img){ img.loading = 'eager'; }); }
  function lbOpen(i){
    var lb = lbBox(); if (!lb || typeof lb.showModal !== 'function' || lb.open) return;
    lbWarm();
    document.documentElement.classList.add('mm-lb-open');
    zoomListen(lb);
    lb.showModal();
    lbGo(i, true);
  }
  function lbClose(){ var lb = lbBox(); if (lb && lb.open) lb.close(); }

  // Zoom in the popup: tap a photo to zoom where you tapped, pinch on phones (up to 3x),
  // then drag (finger, mouse or trackpad) to look around; tap again to zoom back out.
  var Z = {slide: null, img: null, s: 1, bw: 0, bh: 0, moved: false}, P = null, M = null;
  function clamp01(v){ return Math.max(0, Math.min(1, v)); }
  function zoomApply(s, fx, fy, cx, cy){
    // Keep the point (fx, fy) of the photo (0–1 of its width/height) under the screen point (cx, cy)
    var sl = Z.slide, img = Z.img, box = sl.getBoundingClientRect();
    var W = Z.bw * s, H = Z.bh * s;
    var mx = Math.max(0, (box.width - W) / 2), my = Math.max(0, (box.height - H) / 2);
    img.style.width = W + 'px'; img.style.height = H + 'px'; img.style.margin = my + 'px ' + mx + 'px';
    sl.scrollLeft = mx + fx * W - (cx - box.left);
    sl.scrollTop = my + fy * H - (cy - box.top);
    Z.s = s;
  }
  function zoomIn(slide, cx, cy, s){
    var img = slide && slide.querySelector('img'); if (!img) return;
    var r = img.getBoundingClientRect(); if (!r.width) return;
    Z.slide = slide; Z.img = img; Z.bw = r.width; Z.bh = r.height;
    if (!img.hasAttribute('data-sizes')) img.setAttribute('data-sizes', img.getAttribute('sizes') || '');
    slide.classList.add('is-zoomed');
    slide.parentNode.classList.add('is-zoomed');
    lbBox().classList.add('is-zoomed');
    zoomApply(s, clamp01((cx - r.left) / r.width), clamp01((cy - r.top) / r.height), cx, cy);
    img.setAttribute('sizes', Math.round(Z.bw * 3) + 'px'); // fetch the sharpest file for the zoom
  }
  function zoomOut(){
    if (!Z.slide) return;
    Z.img.style.width = Z.img.style.height = Z.img.style.margin = '';
    Z.slide.classList.remove('is-zoomed');
    Z.slide.parentNode.classList.remove('is-zoomed');
    var lb = lbBox(); if (lb) lb.classList.remove('is-zoomed');
    Z.slide.scrollLeft = Z.slide.scrollTop = 0;
    Z.slide = Z.img = null; Z.s = 1; P = null;
  }
  function lbSlide(){ var t = document.getElementById('lb-track'); return t && t.children[lbI]; }
  function mid(e){ return {x: (e.touches[0].clientX + e.touches[1].clientX) / 2, y: (e.touches[0].clientY + e.touches[1].clientY) / 2}; }
  function spread(e){ return Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY) || 1; }
  function zoomListen(lb){
    if (lb.__mmZoom) return; lb.__mmZoom = true;
    lb.addEventListener('touchstart', function(e){
      if (e.touches.length !== 2) return;
      var m = mid(e);
      if (!Z.slide) zoomIn(lbSlide(), m.x, m.y, 1);
      if (!Z.slide) return;
      var r = Z.img.getBoundingClientRect();
      P = {d: spread(e), s: Z.s, fx: clamp01((m.x - r.left) / r.width), fy: clamp01((m.y - r.top) / r.height)};
    }, {passive: true});
    lb.addEventListener('touchmove', function(e){
      if (!P || e.touches.length !== 2) return;
      e.preventDefault();
      var m = mid(e);
      zoomApply(Math.min(3, Math.max(1, P.s * spread(e) / P.d)), P.fx, P.fy, m.x, m.y);
    }, {passive: false});
    lb.addEventListener('touchend', function(e){
      if (!P || e.touches.length > 1) return;
      P = null; Z.pinched = Date.now();
      if (Z.s < 1.08) zoomOut();
    });
    lb.addEventListener('gesturestart', function(e){ e.preventDefault(); }); // iOS: no page zoom behind the popup
    // Mouse: drag the zoomed photo around
    lb.addEventListener('pointerdown', function(e){
      if (e.pointerType !== 'mouse' || !Z.slide || e.button !== 0) return;
      M = {x: e.clientX, y: e.clientY, l: Z.slide.scrollLeft, t: Z.slide.scrollTop}; Z.moved = false;
    });
    lb.addEventListener('pointermove', function(e){
      if (!M || !Z.slide) return;
      var dx = e.clientX - M.x, dy = e.clientY - M.y;
      if (Math.abs(dx) + Math.abs(dy) > 4) Z.moved = true;
      Z.slide.scrollLeft = M.l - dx; Z.slide.scrollTop = M.t - dy;
    });
    window.addEventListener('pointerup', function(){ M = null; });
  }
  function lbTap(e){
    // Taps inside the open popup (arrows and × are handled before this)
    if (Date.now() - (Z.pinched || 0) < 400) return; // a pinch is not a tap
    if (Z.slide) { if (Z.moved) Z.moved = false; else zoomOut(); return; }
    if (e.target.tagName === 'IMG') { zoomIn(e.target.closest('.lb-slide'), e.clientX, e.clientY, 2.5); return; }
    lbClose();
  }
  // "close" doesn't bubble: catch it in the capture phase. Leave the gallery on the photo seen last.
  document.addEventListener('close', function(e){
    if (!e.target || e.target.id !== 'lightbox') return;
    zoomOut();
    document.documentElement.classList.remove('mm-lb-open');
    var t = track(); if (!t) return;
    t.scrollTo({left: lbI * t.clientWidth, behavior: 'auto'});
    setActive(lbI);
    var z = t.children[lbI] && t.children[lbI].querySelector('.slide-zoom');
    if (z) z.focus({preventScroll: true});
  }, true);
  // Start loading the large photos as soon as a finger or the mouse touches the gallery
  document.addEventListener('pointerdown', function(e){
    if (e.target.closest && e.target.closest('[data-zoom]')) lbWarm();
  }, {passive: true});
  document.addEventListener('keydown', function(e){
    var lb = lbBox(); if (!lb || !lb.open) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); lbGo(lbI - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); lbGo(lbI + 1); }
  });

  // Reviews: N per page, "See more" then Back / Next
  function revs(){ return $$('#rev-list .review'); }
  function revPer(){ var l = $('#rev-list'); return (l && parseInt(l.getAttribute('data-per-page'), 10)) || 6; }
  function showRevs(){
    var list = $('#rev-list');
    if (!list) return;
    var all = revs(), n = revPer();
    var pages = Math.max(1, Math.ceil(all.length / n));
    if (!revOpen) revPage = 0;
    revPage = Math.min(Math.max(revPage, 0), pages - 1);
    all.forEach(function(r, i){ r.hidden = i < revPage * n || i >= (revPage + 1) * n; });
    var label = list.getAttribute('data-page-label') || 'Page [page] of [pages]';
    var pg = $('#rev-page'); if (pg) pg.textContent = label.replace('[page]', revPage + 1).replace('[pages]', pages);
    var prev = $('#rev-prev'); if (prev) prev.disabled = revPage === 0;
    var nxt = $('#rev-next'); if (nxt) nxt.disabled = revPage >= pages - 1;
    var more = $('#rev-more'); if (more) more.hidden = revOpen || pages < 2;
    var pager = $('#rev-pager'); if (pager) pager.hidden = !revOpen;
  }
  function revGo(d){
    revPage += d;
    showRevs();
    var list = $('#rev-list');
    if (list && list.getBoundingClientRect().top < 0) $('#reviews').scrollIntoView({behavior: 'smooth', block: 'start'});
  }

  function initSticky(){
    if (io) { io.disconnect(); io = null; }
    var sticky = $('#sticky'), atc = $('#atc');
    if (!sticky || !atc || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(function(entries){
      var visible = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      sticky.classList.toggle('show', !visible);
      sticky.setAttribute('aria-hidden', visible ? 'true' : 'false');
      var b = sticky.querySelector('button'); if (b) b.tabIndex = visible ? -1 : 0;
      var sel = $('#st-select'); if (sel) sel.tabIndex = visible ? -1 : 0;
    });
    io.observe(atc);
  }

  // Customer videos: play only while on screen (saves data on phones); still images if the visitor prefers less motion
  var ugcObs = null;
  function initUgc(){
    if (ugcObs) { ugcObs.disconnect(); ugcObs = null; }
    var vids = $$('video[data-ugc]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!vids.length || reduce || !('IntersectionObserver' in window)) return;
    ugcObs = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var v = en.target;
        if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
        else v.pause();
      });
    }, {threshold: 0.35});
    vids.forEach(function(v){ ugcObs.observe(v); });
  }

  function init(){
    var data = document.getElementById('mm-product-data');
    D = null;
    if (data) { try { D = JSON.parse(data.textContent); } catch (e) { D = null; } }
    if (D) {
      state = {set: D.sets[D.def] ? D.def : 'k1', qty: 1, gift: false, giftWanted: null};
      var r = document.getElementById('set-' + state.set); if (r) r.checked = true;
      gi = 0;
      render();
    }
    revOpen = false; revPage = 0;
    showRevs();
    initSticky();
    initUgc();
  }

  document.addEventListener('click', function(e){
    var t = e.target;
    if (!t.closest) return;
    var b;
    // Header links rewritten to another page's section (data-mm-anchor) scroll here when that section is on this page
    var a = t.closest('a[data-mm-anchor]');
    if (a && !e.defaultPrevented && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && !a.target &&
        a.origin === location.origin && a.hash && a.pathname !== location.pathname) {
      var target = document.getElementById(a.hash.slice(1));
      if (target && !target.contains(a)) {
        e.preventDefault();
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block: 'start'});
        if (history.pushState) history.pushState(null, '', a.hash);
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({preventScroll: true});
        return;
      }
    }
    if (t.closest('[data-add]')) { addToCart(); return; }
    if ((b = t.closest('[data-pick]'))) { pick(b.getAttribute('data-pick')); return; }
    if ((b = t.closest('[data-set-up]'))) { setUp(b.getAttribute('data-set-up')); return; }
    if (t.closest('#qty-minus')) { state.qty = Math.max(1, state.qty - 1); render(); return; }
    if (t.closest('#qty-plus')) { state.qty = Math.min(D ? D.qtyMax : 10, state.qty + 1); render(); return; }
    if ((b = t.closest('[data-zoom]'))) { lbOpen(parseInt(b.getAttribute('data-zoom'), 10)); return; }
    if ((b = t.closest('[data-lb]'))) { lbGo(lbI + parseInt(b.getAttribute('data-lb'), 10)); return; }
    if (t.closest('[data-lb-close]')) { lbClose(); return; }
    if (t.closest('#lightbox')) { lbTap(e); return; }
    if (t.closest('#g-prev')) { showImg(gi - 1); return; }
    if (t.closest('#g-next')) { showImg(gi + 1); return; }
    if ((b = t.closest('.thumb'))) { showImg(parseInt(b.getAttribute('data-i'), 10)); return; }
    if (t.closest('#in-prev')) { $('#inbox-row').scrollBy({left: -320, behavior: 'smooth'}); return; }
    if (t.closest('#in-next')) { $('#inbox-row').scrollBy({left: 320, behavior: 'smooth'}); return; }
    if (t.closest('#rev-more')) { revOpen = true; revPage = 1; showRevs(); return; }
    if (t.closest('#rev-prev')) { revGo(-1); return; }
    if (t.closest('#rev-next')) { revGo(1); return; }
  });

  document.addEventListener('input', function(e){
    if (e.target.id !== 'gift-msg') return;
    var c = $('#msg-count'); if (c) c.textContent = e.target.value.length;
  });

  document.addEventListener('change', function(e){
    var t = e.target;
    if (t.name === 'set' && t.type === 'radio') { state.set = t.value; render(); return; }
    if (t.id === 'st-select') {
      state.set = t.value;
      var r = document.getElementById('set-' + state.set); if (r) r.checked = true;
      render();
      return;
    }
    if (t.id === 'gift-wrap') {
      state.giftWanted = t.checked;
      render();
      return;
    }
    if (t.id === 'msg-on') {
      var box = $('#msg-box');
      t.setAttribute('aria-expanded', t.checked ? 'true' : 'false');
      if (box) box.hidden = !t.checked;
      if (t.checked) { var ta = $('#gift-msg'); if (ta) ta.focus(); }
      return;
    }
    if (t.id === 'country' && D) {
      var c = D.cutoff[t.value];
      var el = $('#cutoff');
      if (el && c) {
        el.textContent = D.cutoffPrefix + ' ';
        var bold = document.createElement('b'); bold.textContent = c; el.appendChild(bold);
      }
    }
  });


  // Theme editor: re-run after a section reloads; open the page or panel holding a selected block
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', function(e){
    var el = e.target;
    if (el.classList && el.classList.contains('review')) {
      var i = revs().indexOf(el);
      if (i >= 0) { revOpen = true; revPage = Math.floor(i / revPer()); showRevs(); }
    }
    if (el.tagName === 'DETAILS') el.open = true;
  });

  // Back/forward cache: refresh the header cart count
  window.addEventListener('pageshow', function(e){
    if (!e.persisted) return;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', {headers: {'Accept': 'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){ var c = document.getElementById('cart-count'); if (c) c.textContent = cart.item_count; })
      .catch(function(){});
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
